<template>
  <md-card>
    <div>
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>supervisor_account</md-icon>
          {{branchInfoData.branchNm}} [{{branchInfoData.branchId}}]
          - 단체 교우 목록
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          <div>
          	교우번호 <input type="text" style="width:70px; vertical-align: middle;" v-model="memberNo">
            회원명 <input type="text" style="width:70px; vertical-align: middle;" v-model="memberHnm">
            <md-button class="md-info md-sm" @click="sendQuery()" style="margin-left: 2px; vertical-align: middle;"><md-icon>check</md-icon>검 색</md-button>
            <md-button class="md-info md-sm" @click="downloadExcel" style="margin-left: 2px; vertical-align: middle;">
              <md-icon>get_app</md-icon>Excel 다운로드
            </md-button>
            <!--            <md-button-->
<!--              class="md-default md-sm ux-wide-btn"-->
<!--              style=" vertical-align: middle; margin-right: 5px;"-->
<!--              @click="showExecutiveListMode"-->
<!--            >-->
<!--              <md-icon>check</md-icon>-->
<!--              임원진 보기-->
<!--            </md-button>-->
            <select v-model="pagination.perPage" name="pages" @change="perPageChange" style="width: 50px; margin-left: 5px; vertical-align: middle;">
              <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <grid ref="groupMemberList"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :theme="gridProps.theme"
              :rowHeaders="gridProps.rowHeaders"
              :columnOptions="gridProps.columnOptions"
              :language="gridProps.lang"
              @dblclick="onDbClickExecutive"
              @response="response"
        ></grid>
      </md-card-content>
      <slot name="bottomRightArea"></slot>
    </div>
  </md-card>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  name: "GroupMemberListComp",
  props: {
    viewListMode : {
      type: Number,
      default: 1
    }
  },
  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  watch : {
    'viewListMode' (n){
      if(n == 1){
        this.sendQuery();
      }
    }
  },

  data() {
    return {
      memberHnm : null,
      memberNo : "",
      branchInfoData : {},
      gridProps: {},
      pagination: {
        perPage: 100,
        page: 1,
        perPageOptions: [20, 50, 100, 300, 500],
        total: 0
      }
    };
  },
  methods: {
    clearView (){
      this.memberHnm = '';
    },
    showExecutiveListMode (){
      this.$emit('update:viewListMode', 2);
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.groupMemberList, event, this.pagination);
    },

    sendQuery(branchInfo) {
      if(branchInfo){
        this.branchInfoData = branchInfo;
      }
      this.$refs.groupMemberList.invoke("readData", 1, {branchId : this.branchInfoData.branchId, memberHnm : this.memberHnm, memberNo : this.memberNo, branchGb : this.branchInfoData.branchGb});
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_BRANCH_MEMBER_LIST, false, this.pagination, ['rowNum','checkbox']);
      this.gridProps['el'] = this.$refs.groupMemberList;
      this.gridProps['columns']= [
        {header: '교우번호', name: 'memberNo', align:"center", width:80, sortable: true,
          formatter(value) {
            return `<span style="color:#0091d5; text-decoration:underline; cursor:pointer">${value.value}</span>`;
          }
        },
        {header: '교우명', name: 'memberHnm', align:"center", width:100, sortable: true},
        {header: '직책', name: 'positionNm', align:"center", width:100, sortable: true},
        {header: '대학코드', name: 'collegeCd', align:"center", width:120, sortable: true},
        {header: '대학명', name: 'collegeNm', align:"center", width:120, sortable: true},
        {header: '학과코드', name: 'classCd', align:"center", width:120, sortable: true},
        {header: '학과명', name: 'classNm', align:"center", width:160, sortable: true},
        {header: '학번', name: 'hakbun', align:"center", sortable: true},
        {header: '졸업회수', name: 'graduationNo', align:"right", width:80, sortable: true},
        {header: '졸업년도', name: 'graduationYm', align:"center", sortable: true},
        {header: '입학년도', name: 'enterYm', align:"center", width:100, sortable: true},
        {header: '직장명', name: 'companyNm', width:120, sortable: true},
        {header: '부서', name: 'partNm', width:100, sortable: true},
        {header: '직위', name: 'levelNm', width:100, sortable: true},
        {header: '교우직위', name: 'levelCdNm', align:"center", width:100, sortable: true},
        {header: '발송구분', name: 'postplace', align:"center", width:60, sortable: true},
        {header: '미발송사유', name: 'nonpostGb', width:100, align:"center", sortable: true}
        ];
    },

    response(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
        this.$refs.groupMemberList.invoke("refreshLayout");
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    getSelectedMember(){
      return this.$refs.groupMemberList.invoke('getCheckedRows');
    },

    onDbClickExecutive(e) {
      if(e.columnName === "memberNo" && e.instance.getRow(e.rowKey) != null) {
        this.$emit('setExcutiveData', e.instance.getRow(e.rowKey));
        window.open('/Friendship/UpdateMember/' + e.instance.getRow(e.rowKey).memberNo, 'FriendshipUpdateMember');
      }
    },

    downloadExcel() {
      if(this.pagination.total < 1){
        kuaaFnc.showSwal("Excel 다운로드", '검색후 진행해 주세요');
        return false;
      }

      let query = {
        branchId: this.branchInfoData.branchId,
        memberHnm : this.memberHnm,
        memberNo : this.memberNo,
        branchGb : this.branchInfoData.branchGb,
        page: 1,
        perPage: this.pagination.total,
        fileName: '단체회원목록'
      };

      kuaaApi.requestFileDownload(
          URL_CONST.BRANCH_MEMBER_EXCEL_DOWNLOAD,
          query,
          '단체회원목록.xlsx',
          response => {
            // this.query.page = this.pagination.page;
            // this.query.perPage = this.pagination.perPage;
          }
      );
    }
  }
};
</script>

<style lang="css" scoped>

</style>